import { useContext } from 'react'

import {
  Box, Button, ModalContext, SidebarModal, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { LocationModel } from '@models/types'

const renderLocations = (locations: LocationModel[]) => locations.map(location => {
  const { distanceUnit, radius, suburb } = location

  const hasRadiusAndDistanceUnit = radius !== null && distanceUnit
  const text = hasRadiusAndDistanceUnit ? `${radius} ${distanceUnit}` : ''

  return (
    <Box alignItems="center" justifyContent="space-between" marginBottom="large">
      <Text fontSize="small">{suburb}</Text>

      <Text color="bodyFontLightColor" fontSize="small">{text}</Text>
    </Box>
  )
})

const MODAL_KEY = 'SelectedLocationsModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const SelectedLocationsModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const adQueue = digObject(modalPayload, 'adQueue', {})

  const { locations } = adQueue

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Selected" titleSecondLine="Locations" />

      <SidebarModal.Content>
        {renderLocations(locations)}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          onClick={() => closeModal()}
          size="large"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <SelectedLocationsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
